import React from 'react'
import OtpInput from 'react-otp-input';
import "./index.scss";


const OTPInputCOmponent = ({ handleChange, otp, numInputs, separator }) => {

    return (
        <div className='otp-form d-flex justify-content-flex-start my-2'>
            <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={numInputs}
                separator={separator}
            />
        </div>
    )
}


export default OTPInputCOmponent